import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@lciapps/auth';

@Component({
  selector: 'app-auth-callback',
  template: `
    <p></p>
  `
})
export class AuthCallbackComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {
    history.replaceState(
      'callback',
      'callback',
      location.origin + location.pathname + decodeURIComponent(location.hash)
    );
    this.authService
      .completeAuthorization()
      .then(user => {

        const url = localStorage.getItem('auth-callback-return-url');
        if (url) {
          this.router.navigateByUrl(url);
        } else {
          this.router.navigate(['/']);
        }
      })
      .catch(err => {
        this.authService.manager.clearStaleState().then(() => {
          this.authService.loggedIn$.subscribe(loggedIn => {
            if (loggedIn) {
              this.router.navigate(['/']);
            } else {
              this.authService.login();
            }
          });
          this.authService.addOidcListeners();
          this.authService.manager.getUser().then(user => {
            this.authService.user = user;
            if (
              this.authService.user !== null &&
              !this.authService.user.expired
            ) {
              this.authService.setLoggedIn(true);
            } else {
              this.authService.setLoggedIn(false);
            }
          });
        });
      });
  }
}
